import React from 'react';
import Translator from "src/requests/apa/Translator";
import { FavoritedNotificationMessage, EventReminderNotificationMessage, NotificationMessage, FutureEventNotAvailableNotificationMessage } from 'src/components/Notification/CustomNotificationMessage';
import { HideMiniEpgFromNewPlayerControlsObserver, ShowPlayerControlsObserver } from 'src/components/PersistentMiniEpg/MiniObserver';
import { NPRV_SCHEDULED_STRING, NPRV_SCHEDULED_STRING_CANCEL, NPVR_RECORDING_STRING, NPVR_RECORDING_STRING_CANCEL, NPVR_RECORDED_STRING, NPVR_RECORDED_STRING_CANCEL, NPVR_NO_SPACE_TO_RECORD_ERROR_CODE } from '../AAF/Npvr/Constans';
import LayersControl from 'src/utils/LayersControl'
import { setReloadMisContenidos } from 'src/utils/Utils';
import Metadata from 'src/requests/apa/Metadata';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';

/*
 * action types
 */
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

/*
 * action creators
 */
export const showNotification = (notificationProps) => dispatch => {
  if (LayersControl.isPlayerVisible()) {
    // cerramos Mini si esta abierta desde PC si esta reproduciendo solamente para todas las notificaciones
    HideMiniEpgFromNewPlayerControlsObserver.fire();
  }
  dispatch({
    type: SHOW_NOTIFICATION,
    notificationProps
  });
};

export const hideNotification = (notificationProps) => dispatch => {
  dispatch({
    type: HIDE_NOTIFICATION,
    notificationProps
  })
};

const getShortcutVisibleKey = () => {
  let metadataKey = Metadata.get('notification_message_recordings_shortcut_visible', '{"default":{"add":true, "cancel":false}}');
  metadataKey = JSON.parse(metadataKey);
  const region = DeviceStorage.getItem('region');
  return metadataKey[region] || metadataKey['default'];
}

export const showRecordingNotification = (recordiongStatus, handleYellowPress = null, titlaAndAsset = {}, isEpisode = false, isSerie = false
) => dispatch => {

  let hasShortcut = true;
  const shortcutVisible = getShortcutVisibleKey();
  
  setReloadMisContenidos(true);

  const closeNotification = () => {
    dispatch(hideNotification({
      show: false,
      title: '',
      msg: ''
    }))
  }
  let title, message, renderMessage;
  const buttons = [
    {
      onClick: () => {
        handleYellowPress();
        closeNotification();
      },
      color: 'yellow',
      label: Translator.get('mycontent_notification_button', 'MIS CONTENIDOS')
    }
  ];
  switch (recordiongStatus) {
    //TODO cambiar status por el correcto
    //Revisar si ya existen llaves para los textos
    case NPRV_SCHEDULED_STRING:
      title = titlaAndAsset && titlaAndAsset.label || 'Por grabar';
      if (isEpisode) {
        message = Translator.get('recording_alert_description_futureEpisode_label', 'El episodio se agregará a tu sección');
      } else if (isSerie) {
        message = Translator.get('recording_alert_description_futureSeason_label', 'Podrás encontrar los episodios de la temporada en la sección');
      } else {
        message = Translator.get('recording_alert_description_futureEvent_label', 'Al finalizar el programa podrás encontrarlo en tu sección');
      }
      hasShortcut = shortcutVisible.add;
      break;
    case NPVR_RECORDING_STRING:
      title = titlaAndAsset && titlaAndAsset.label || 'Grabando';
      if (isEpisode) {
        message = Translator.get('recording_alert_description_presentEpisode_label', 'El episodio se agregará a tu sección');
      } else if (isSerie) {
        message = Translator.get('recording_alert_description_presentSeason_label', 'Podrás encontrar los episodios de la temporada en tu sección');
      } else {
        message = Translator.get('recording_alert_description_presentEvent_label', 'Al finalizar el programa podrás encontrarlo en tu sección');
      }
      hasShortcut = shortcutVisible.add;
      break;
    case NPVR_RECORDED_STRING:
      title = titlaAndAsset && titlaAndAsset.label || 'Grabado';
      if (isEpisode) {
        message = Translator.get('recording_alert_description_pastEpisode_label', 'El episodio se agregó a tu sección');
      } else if (isSerie) {
        message = Translator.get('recording_alert_description_pastSeason_label', 'Los episodios de la temporada se agregarán a la sección');
      } else {
        message = Translator.get('recording_alert_description_pastEvent_label', 'El programa fue agregado a tu sección');
      }
      hasShortcut = shortcutVisible.add;
      break;
    case NPRV_SCHEDULED_STRING_CANCEL:
      title = titlaAndAsset && titlaAndAsset.label || 'Cancelaste la grabación';
      if (isEpisode) {
        message = Translator.get('cancelRecording_alert_description_futureEpisode_label', 'Se canceló la grabación del episodio');
      } else if (isSerie) {
        message = Translator.get('cancelRecording_alert_description_futureSeason_label', 'Se canceló la grabación de la temporada');
      } else {
        message = Translator.get('cancelRecording_alert_description_futureEvent_label', 'Se cancelo la grabación del programa');
      }
      hasShortcut = shortcutVisible.cancel;
      break;
    case NPVR_RECORDING_STRING_CANCEL:
      title = titlaAndAsset && titlaAndAsset.label || 'Dejaste de grabar';
      if (isEpisode) {
        message = Translator.get('stopRecording_alert_description_presentEpisode_label', 'El episodio se eliminó de la sección Mis contenidos');
      } else if (isSerie) {
        message = Translator.get('stopRecording_alert_description_presentSeason_label', 'Se eliminó la temporada completa de tu sección Mis contenidos');
      } else {
        message = Translator.get('stopRecording_alert_description_presentEvent_label', 'La grabación se eliminó de la sección de Mis contenidos');
      }
      hasShortcut = shortcutVisible.cancel;
      break;
    case NPVR_RECORDED_STRING_CANCEL:
      title = titlaAndAsset && titlaAndAsset.label || 'Eliminaste la grabación';
      if (isEpisode) {
        message = Translator.get('deleteRecording_alert_description_pastEpisode_label', 'El episodio se eliminó de la sección Mis contenidos');
      } else if (isSerie) {
        message = Translator.get('deleteRecording_alert_description_pastSeason_label', 'Se eliminó la temporada completa de tu sección Mis contenidos');
      } else {
        message = Translator.get('deleteRecording_alert_description_pastEvent_label', 'La grabación se eliminó de la sección de Mis contenidos');
      }
      hasShortcut = shortcutVisible.cancel;
      break;
    case NPVR_NO_SPACE_TO_RECORD_ERROR_CODE:
        title = titlaAndAsset && titlaAndAsset.label || 'Espacio insuficiente';
        message = Translator.get(`${NPVR_NO_SPACE_TO_RECORD_ERROR_CODE}_message`, 'Adminstra tus grabaciones en la sección');
        hasShortcut = shortcutVisible.add;
        break;
    default:
        title = Translator.get('_',"Por grabar");
        message = Translator.get(
          '_',
          'Al finalizar el programa podrás encontrarlo en tu sección'
        );
        hasShortcut = shortcutVisible.add;
  }
  if (hasShortcut) {
    dispatch(showNotification({
      show: true,
      title: title,
      renderMessage: () => {
        return (
          <NotificationMessage message={message} buttons={buttons}/>
        );
      },
      apaAsset: titlaAndAsset && titlaAndAsset.imageSrc || 'player_controls_record_icon',
      type: 'message',
      handleYellowPress
    }));
  } else {
    dispatch(showNotification({
      show: true,
      title: title,
      renderMessage: () => {
        return (
          <NotificationMessage message={message}/>
        );
      },
      apaAsset: titlaAndAsset && titlaAndAsset.imageSrc || 'player_controls_record_icon',
      type: 'message'
    }));
  }
}

export const showNoSpaceToRecordNotification = (notificationProps, message, handleYellowPress) => dispatch => {
  const closeNotification = () => {
    dispatch(hideNotification({
      show: false,
      title: '',
      msg: ''
    }))
  }
  const buttons = [
    {
      onClick: () => {
        handleYellowPress();
        closeNotification();
      },
      color: 'yellow',
      label: Translator.get('mycontent_notification_button', 'MIS CONTENIDOS')
    }
  ];

  dispatch(showNotification({
    show: true,
    ...notificationProps,
    renderMessage: () => {
      return (
        <NotificationMessage message={message} buttons={buttons} />
      );
    },
    handleYellowPress
  }));
}

export const showBlockedChannelNotification = (channelName = null) => dispatch => {
  const title = Translator.get("lockChannel_alert_title_label", "Canal @canal bloqueado").replace('@canal', channelName);
  const message = Translator.get("lockChannel_alert_description_label", "Para ver este canal necesitarás tu PIN de seguridad");
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    apaAsset: 'playingLive_channel_option_button_lockChannel',
    apaAssetDefault: '/images/ic_block.png',
    type: 'message'
  }));
}


export const showUnBlockedChannelNotification = (channelName = null) => dispatch => {
  const title = Translator.get("unlockChannel_alert_title_label", "Canal @canal desbloqueado").replace('@canal', channelName);
  const message = '';
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    apaAsset: 'playingLive_alert_unlockChannel_icon',
    apaAssetDefault: '/images/ic_block.png',
    type: 'message'
  }));
}

export const showToggleFavoritedChannelNotification = (isFavorite, handleYellowPress = null) => dispatch => {
  const hasShortcode = Translator.get('recording_alert_option_button_myContents', '')
  const closeNotification = () => {
    dispatch(hideNotification({
      show: false,
      title: '',
      msg: ''
    }))
  }
  if (isFavorite) {
    if (hasShortcode !== '') {
      dispatch(showNotification({
        show: true,
        title: Translator.get("addFavorites_alert_title_label", "Añadido a canales favoritos"),
        renderMessage: () => {
          return (
            <FavoritedNotificationMessage handleYellowPress={handleYellowPress} closeNotification={closeNotification} />
          );
        },
        apaAsset: 'playingLive_alert_channelFavorite_icon',
        apaAssetDefault: '/images/ic_favorite.png',
        type: 'message',
        handleYellowPress
      }));
    } else {
      dispatch(showNotification({
        show: true,
        title: Translator.get("addFavorites_alert_title_label", "Añadido a canales favoritos"),
        msg: Translator.get('addFavorites_alert_description_label', 'Consulta tus canales favoritos en la Guía Completa'),
        separator: Translator.get('addFavorites_alert_separatorPipe_format', '|'),
        apaAsset: 'playingLive_alert_channelFavorite_icon',
        apaAssetDefault: '/images/ic_favorite.png',
        type: 'message'
      }));
    }
  }
  else {
    // TODO agregar titulo y mensaje correctos
    dispatch(showNotification({
      show: true,
      title: Translator.get("deleteFavorite_alert_title_label", "Eliminado de favoritos"),
      msg: Translator.get("deleteFavorite_alert_description_label", "El canal fue eliminado de a la sección Mis contenidos"),
      separator: Translator.get('addFavorites_alert_separatorPipe_format', '|'),
      // apaAsset: 'playingLive_program_option_button_favorites',
      apaAsset: 'playingLive_alert_channelFavorite_icon',
      apaAssetDefault: '/images/ic_favorite.png',
      type: 'message'
    }));
  }
}

export const showToReminderNotification = () => dispatch => {
  const title = Translator.get("addReminder_alert_title_futureEvent_label", "Recordatorio programado");
  const message = Translator.get("addReminder_alert_description_futureEvent_label", "Recibirás una notificación antes de que el programa comience");
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    apaAsset: 'playingLive_programFuture_option_button_reminder',
    apaAssetDefault: '/images/ic_clock.png',
    type: 'message',
    //TODO mostrar los nuevos player controls
    // closeNotificationCallback: () => {
    //   ShowPlayerControlsObserver.fire();
    // }
  }));
}

export const showReminderRemovedNotification = () => dispatch => {
  const title = Translator.get("deleteReminder_alert_title_futureEvent_label", "Eliminaste el recordatorio");
  const message = Translator.get("deleteReminder_alert_description_futureEvent_label", "Se eliminó el recordatorio del programa");
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    apaAsset: 'playingLive_programFuture_option_button_reminder',
    apaAssetDefault: '/images/ic_clock.png',
    type: 'message',
  }));
}

export const showEventReminderNotification = (event = {}, handleRedPress = null, handleGreenPress = null) => dispatch => {
  const closeNotification = () => {
    dispatch(hideNotification({
      show: false,
      title: '',
      msg: ''
    }))
  }
  dispatch(showNotification({
    show: true,
    title: event.name,
    apaAsset: 'playingLive_programFuture_option_button_reminder',
    apaAssetDefault: '/images/ic_clock.png',
    type: 'notification',
    handleRedPress,
    handleGreenPress,
    renderMessage: () => {
      //event: { channelNumber: '199', channelImage: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/FOX-Channel-Germany.svg/1280px-FOX-Channel-Germany.svg.png', schedule: '16.30hs a 18.30hs'}
      return (
        <EventReminderNotificationMessage event={event} handleRedPress={handleRedPress} handleGreenPress={handleGreenPress} closeNotification={closeNotification} />
      )
    }
  }));
}

export const showPassEventNotAvailableNotification = () => dispatch => {
  const title = Translator.get("timeshift_alert_title_not_available_pastEvent_label", "No disponible");
  const message = Translator.get("timeshift_alert_description_not_available_pastEvent_label", "En este canal no puedes ver programas ya emitidos");
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    type: 'message'
  }));
}

export const showNotFavoriteChannels = () => dispatch => {
  const title = Translator.get("filterSelector_alert_title_notfavorites_label", "Aún no tienes canales favoritos");
  const message = Translator.get("filterSelector_alert_description_notfavorites_label", "Agrega algunos desde las opciones de cada canal");
  dispatch(showNotification({
    show: true,
    title: title,
    msg: message,
    type: 'message'
  }));
}

export const showFutureEventNotAvailableNotification = (handleBluePress = null) => dispatch => {
  const closeNotification = () => {
    dispatch(hideNotification({
      show: false,
      title: '',
      msg: ''
    }))
  }
  const title = Translator.get("timeshift_alert_title_not_available_futureEvent_label", "Aún no disponible");
  dispatch(showNotification({
    show: true,
    title,
    type: 'message',
    handleBluePress,
    renderMessage: () => {
      return (
        <FutureEventNotAvailableNotificationMessage handleBluePress={handleBluePress} closeNotification={closeNotification} />
      )
    },
  }));
}

export const showFunctionNotAvailableNotification = (handleBluePress = null) => dispatch => {
  const title = Translator.get("timeshift_alert_title_not_available_label", "Acción no disponible");
  dispatch(showNotification({
    show: true,
    title,
    type: 'message',
    handleBluePress
  }));
}

export const showPlayerBackwardForwardNotAvailableNotification = () => dispatch => {
  const title = Translator.get("timeshift_alert_title_not available_label", "Acción no disponible");
  const msg = Translator.get("timeshift_alert_description_not_available_label", "En este canal no puedes avanzar o retroceder en la reproducción ni grabar los programas");

  dispatch(showNotification({
    show: true,
    title,
    msg,
    type: 'message'
  }));
}

export const showPlayerEventRecordingNotAvailableNotification = () => dispatch => {
  const title = Translator.get("no_recording_alert_title_not_available_label", "Acción no disponible");
  const msg = Translator.get("no_recording_alert_description_not_available_label", "Este programa no se puede grabar");

  dispatch(showNotification({
    show: true,
    title,
    msg,
    type: 'message'
  }));
}


// WEBPACK FOOTER //
// ./src/actions/notification.js